import { CheckCircleFilled, CopyOutlined } from "@payping/icons";
import { Trans } from "@payping/utils/localeUtils";
import { Button, Col, Flex, Modal, Row, Typography, message, usePaypingContext } from "@payping/web-components";
import copy from "copy-to-clipboard";
import { Dispatch, FC, SetStateAction } from "react";
import { useAppTranslation } from "@/utils";

export interface ConfirmModalProps {
  open?: boolean;
  setOpen?: Dispatch<SetStateAction<boolean>>;
  token?: string;
  showGuide?: boolean;
  client?: { clientId?: string; clientSecret?: string; backToList?: boolean };
}

export const ConfirmModal: FC<ConfirmModalProps> = (props) => {
  const { breakpoints } = usePaypingContext();
  const { md } = breakpoints;
  const { open, setOpen, token, client, showGuide } = props;
  const { t } = useAppTranslation();
  const isOauth = Boolean(client?.clientId);

  return (
    <Modal
      title={isOauth ? t("oauth.oauthShow") : t("token.tokenShow")}
      open={open}
      className={!md ? "tw:top-2.5" : ""}
      onCancel={() => setOpen?.(false)}
      footer={null}
    >
      <Row justify={"center"} gutter={[16, 16]}>
        <Col xs={24} className="tw:flex tw:justify-center">
          <CheckCircleFilled className="color--success" width={70} />
        </Col>
        <Col xs={24} className="tw:flex tw:justify-center">
          <Typography.Title level={4}>
            {isOauth ? t("oauth.show.successMessage") : t("token.show.successMessage")}
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <div className="background--gray100 tw:px-8! tw:py-8!">
            <Flex vertical gap={"middle"}>
              {showGuide ? (
                <Typography.Text>
                  <Trans i18nKey={t("Ipg:oauth.show.oauthGuideMessage")} components={{ bold: <b /> }} />
                  <br />
                </Typography.Text>
              ) : null}
              <Typography.Text strong>{t("token.show.tokenAttention")}</Typography.Text>
              <Flex vertical>
                <Typography.Text strong>{isOauth ? "ClientId" : "Token"}</Typography.Text>
                <Button
                  type={"dashed"}
                  icon={<CopyOutlined width={14} height={14} />}
                  className={`en-font tw:flex tw:w-full tw:flex-row tw:items-center tw:justify-center tw:overflow-hidden tw:font-medium ${
                    !md && "tw:overflow-x-scroll"
                  }`}
                  onClick={() => {
                    if (client?.clientId) {
                      const copied = copy(client.clientId);
                      if (copied) message.success({ content: t("messages.copied") });
                    } else if (token) {
                      const copied = copy(token);
                      if (copied) message.success({ content: t("messages.copied") });
                    }
                  }}
                >
                  {isOauth ? client?.clientId : token?.slice(0, 35)}
                </Button>
              </Flex>
              <Flex vertical>
                {client?.clientSecret ? (
                  <>
                    <Typography.Text strong>ClientSecret</Typography.Text>
                    <Button
                      type={"dashed"}
                      className={`en-font tw:flex tw:w-full tw:flex-row tw:items-center tw:justify-center tw:font-medium ${
                        !md && "tw:overflow-x-scroll"
                      }`}
                      icon={<CopyOutlined width={14} height={14} />}
                      onClick={() => {
                        if (client?.clientSecret) {
                          const copied = copy(client.clientSecret);
                          if (copied) message.success({ content: t("messages.copied") });
                        }
                      }}
                    >
                      {client.clientSecret}
                    </Button>
                  </>
                ) : null}
              </Flex>
            </Flex>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};
